// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Salary-Section{
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
}
.SalaryCal-Section{
    width: 50%;
    height: auto;
    border-radius: 2vh;
    background-color: #c9e0c9;
    padding: 1%;

}
.SalaryFilter{
    width: auto;
    height: auto;
    padding: 1%;
    border-radius:2vh ;
    background-color: #99dd98;
}
.Salary-MetaData{
    display: flex;
    align-items: center;
    justify-content: center;
}
.Salary-MetaData  select{
    width: 10vw;
    border: 0;
}

.Salary-Demo-Price{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.DemoPrice,.DemoTotal{
    width: auto;
    padding: 4%;
    margin:2% 0 2% 0 ;
    background-color: #99dd98;
    border-radius: 2vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    float: left;
}
.DemoInputs{
    
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-bottom:3vh ;

}
.Demo-input{
    width: 10vw;
    color: gray;
    border: 0;
    padding: 2%;
    border-radius: 1vh;
}

.GenSalary{
    display: flex;
    align-items: center;
    justify-content: center;
}
.SalaryBtn{
    background-color: #99dd98;
    border-radius: 2vh;
    padding: 2%;
    font-weight: bold;
    border: 0;
    color: rgb(26, 24, 24);
}


/* salary */
/* CSS File (e.g., styles.css) */

.SAL-Teacher{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.salary-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
  }
  
  .salary-table th,
  .salary-table td {
    padding: 10px;
    text-align: left;
    border: 1px solid #dddddd;
  }
  
  .salary-table th {
    background-color: #f2f2f2;
  }
  
  .salary-table tbody tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  .salary-table tbody tr:hover {
    background-color: #e9e9e9;
  }
  `, "",{"version":3,"sources":["webpack://./src/MyComponents/AdminActions/TeacherSalary.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;;AAEf;AACA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;AACA;;IAEI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;;AAEtB;AACA;IACI,WAAW;IACX,WAAW;IACX,SAAS;IACT,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,SAAS;IACT,sBAAsB;AAC1B;;;AAGA,WAAW;AACX,gCAAgC;;AAEhC;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;;IAEE,aAAa;IACb,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".Salary-Section{\n    width: 100%;\n    height: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.SalaryCal-Section{\n    width: 50%;\n    height: auto;\n    border-radius: 2vh;\n    background-color: #c9e0c9;\n    padding: 1%;\n\n}\n.SalaryFilter{\n    width: auto;\n    height: auto;\n    padding: 1%;\n    border-radius:2vh ;\n    background-color: #99dd98;\n}\n.Salary-MetaData{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.Salary-MetaData  select{\n    width: 10vw;\n    border: 0;\n}\n\n.Salary-Demo-Price{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n}\n\n.DemoPrice,.DemoTotal{\n    width: auto;\n    padding: 4%;\n    margin:2% 0 2% 0 ;\n    background-color: #99dd98;\n    border-radius: 2vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    float: left;\n}\n.DemoInputs{\n    \n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    margin-bottom:3vh ;\n\n}\n.Demo-input{\n    width: 10vw;\n    color: gray;\n    border: 0;\n    padding: 2%;\n    border-radius: 1vh;\n}\n\n.GenSalary{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.SalaryBtn{\n    background-color: #99dd98;\n    border-radius: 2vh;\n    padding: 2%;\n    font-weight: bold;\n    border: 0;\n    color: rgb(26, 24, 24);\n}\n\n\n/* salary */\n/* CSS File (e.g., styles.css) */\n\n.SAL-Teacher{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n.salary-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 20px;\n  }\n  \n  .salary-table th,\n  .salary-table td {\n    padding: 10px;\n    text-align: left;\n    border: 1px solid #dddddd;\n  }\n  \n  .salary-table th {\n    background-color: #f2f2f2;\n  }\n  \n  .salary-table tbody tr:nth-child(even) {\n    background-color: #f9f9f9;\n  }\n  \n  .salary-table tbody tr:hover {\n    background-color: #e9e9e9;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
